import { useNativePushRegistration } from '@/hooks/useNativePushRegistration';
import { usePushDeepLink } from '@/hooks/usePushDeepLink';
import { PushBanner } from '@/components/mobile/PushBanner';

/**
 * Single mount point for the native-only push surfaces. Mount inside the
 * authenticated layout so it runs after login only.
 *
 * - `useNativePushRegistration` requests permission + registers the device
 *   token with the backend on first auth (no-op on web).
 * - `usePushDeepLink` routes system-tray taps via `pushNotificationActionPerformed`
 *   (no-op on web).
 * - `<PushBanner />` renders an in-app banner for foreground deliveries
 *   (`pushNotificationReceived`); native-only by construction — renders null
 *   on web and never subscribes.
 */
export function NativePushBootstrap() {
  useNativePushRegistration();
  usePushDeepLink();
  return <PushBanner />;
}
